module.exports = __webpack_public_path__ + "img/research_4.1b0cbb57.png";